import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { getPageTitle, managesOwnHead } from '@/navigation/pageTitles';

/**
 * usePageTitle - sets document.title from the current route (see navigation/pageTitles.ts).
 * Routes without an entry (the public home page, print views) keep whatever title the page set.
 * Called once, from App.
 */
export function usePageTitle(): void {
  const { pathname } = useLocation();
  const defaultTitle = useRef(document.title);

  useEffect(() => {
    if (pathname === '/') {
      document.title = defaultTitle.current;
      return;
    }
    if (managesOwnHead(pathname)) return;
    const title = getPageTitle(pathname);
    if (title) document.title = title;
  }, [pathname]);
}
